
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '../../../store/modules/user';
import { getOrderDetail } from '../../../api/order';
import dialogImgLarge from '@/components/ImgLarge/index.vue';

@Component({
  name: 'DeviceDetail',
  components: {
    dialogImgLarge
  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogDeviceRecordDetailVisible!:Boolean;
  @Prop({
    type: Object,
    default: () => ({})
  })detaiData!:Object;
  @Prop({
    type: Object,
    default: () => ({})
  })deviceData!:Object;
  created() {
    this.getDetail();
  }
private locDetail:any={
  order: {},
  order_service: {}
};
private getDetail() {
  var map:any = {};
  map.company_id = UserModule.getCompanyId;
  map.user_id = UserModule.getUserId;
  map.order_id = (this.detaiData as any).order.id;
  map.user_name = UserModule.getUserName;
  map.customer_user_id = (this.detaiData as any).order.customer_user_id;
  map.customer_company_id = (this.detaiData as any).order.customer_company_id;
  map.create_user_id = (this.detaiData as any).order.create_user_id;
  getOrderDetail(map).then(res => {
    if (res.data) {
      this.locDetail = res.data;
    } else {
      this.locDetail = {};
    }
  }).catch(err => {
    let msg = err.msg;
  });
}
private getCusName(device:any) {
  // 目前获取自己公司 个人名称
  let name = '';
  if (UserModule.getCompanyName) {
    name = UserModule.getCompanyName;
  } else {
    name = UserModule.getUserName;
  }
  return name;
}
private close() {
  this.$emit('close', false);
}

private imgLargeHandle(val: [], index: number) {
  let enlargedData = {
    isShow: true,
    imgList: val,
    initNum: index
  };
  this.$store.dispatch('toggleEnlarged', enlargedData);
}
}
